import React from "react";
import { ImFilesEmpty } from "react-icons/im";

export const AppTableNoData = ({classes = '', message = 'No data available in table'}) => {
  return (
    <div className={`row text-center border mx-0 ${classes}`} style={{ marginTop: "-1rem", marginBottom: "1rem" }}>
      <div className="p-2 text-muted fs-4">{message}</div>
      <div className="pb-2 text-muted">
        <ImFilesEmpty size={70} />
      </div>
    </div>
  );
};
